// Jours fériés France métropole + La Réunion — algorithme réel (comput de
// Pâques + dates fixes), porté tel quel depuis MyALFA Worksync Test V2/
// store.jsx (window.Holidays). Déterministe, pas une donnée à inventer.
const _cache = {};

function easter(y) {
  const a = y % 19,
    b = Math.floor(y / 100),
    c = y % 100,
    d = Math.floor(b / 4),
    e = b % 4,
    f = Math.floor((b + 8) / 25),
    g = Math.floor((b - f + 1) / 3),
    h = (19 * a + b - d - g + 15) % 30,
    i = Math.floor(c / 4),
    k = c % 4,
    l = (32 + 2 * e + 2 * i - h - k) % 7,
    m = Math.floor((a + 11 * h + 22 * l) / 451),
    mo = Math.floor((h + l - 7 * m + 114) / 31),
    da = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(y, mo - 1, da);
}

function toIso(d) {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

function addDays(d, n) {
  const x = new Date(d);
  x.setDate(x.getDate() + n);
  return x;
}

// region: "france" | "reunion" → { "YYYY-MM-DD": "Nom du jour férié" }
export function holidaysForYear(year, region) {
  const key = `${year}:${region}`;
  if (_cache[key]) return _cache[key];
  const E = easter(year);
  const list = [
    [new Date(year, 0, 1), "Jour de l'An"],
    [addDays(E, 1), "Lundi de Pâques"],
    [new Date(year, 4, 1), "Fête du Travail"],
    [new Date(year, 4, 8), "Victoire 1945"],
    [addDays(E, 39), "Ascension"],
    [addDays(E, 50), "Lundi de Pentecôte"],
    [new Date(year, 6, 14), "Fête nationale"],
    [new Date(year, 7, 15), "Assomption"],
    [new Date(year, 10, 1), "Toussaint"],
    [new Date(year, 10, 11), "Armistice 1918"],
    [new Date(year, 11, 25), "Noël"],
  ];
  if (region === "reunion") list.push([new Date(year, 11, 20), "Abolition de l'esclavage"]);
  const map = {};
  list.forEach(([d, n]) => {
    map[toIso(d)] = n;
  });
  _cache[key] = map;
  return map;
}

export function holidayName(iso, region = "reunion") {
  const year = Number(iso.slice(0, 4));
  return holidaysForYear(year, region)[iso] || null;
}
